import React from "react";

const Header = () => {
  return <div className="p-8 bg-white shadow-md rounded-lg">
    <h1 className="text-2xl font-bold font-heebo text-center text-black">My secret messages</h1>
  </div>
};

export default Header;
